@if (formLoadState === "loading" || formLoadState === "idle") {
	<div class="flex min-h-[40vh] items-center justify-center px-6 py-12 text-sm text-gray-600">Loading form…</div>
} @else if (formLoadState === "error") {
	<div class="px-6 py-8">
		<p class="text-base text-black">{{ formLoadError }}</p>
		<button type="button" class="aa-btn mt-4" data-variant="tertiary" (click)="goBackFromLoadError()">Back</button>
	</div>
} @else if (formType == FORM_TYPE.ts_1) {
	@switch (ratingFormUiVersion) {
		@case (ratingFormUiCaseTs1V4) {
			<app-ts1-rating-form-v4></app-ts1-rating-form-v4>
		}
		@case (ratingFormUiCaseTs1V3) {
			<app-ts1-rating-form-v3></app-ts1-rating-form-v3>
		}
		@case (ratingFormUiCaseV2) {
			<app-ts1-rating-form-v2></app-ts1-rating-form-v2>
		}
		@default {
			<!-- Wait for async IndexedDB / configVersion hydration — never mount legacy v2 by default -->
			<div class="flex min-h-[40vh] items-center justify-center px-6 py-12 text-sm text-gray-600">Loading form…</div>
		}
	}
} @else if (formType == FORM_TYPE.ts_6) {
	@switch (ratingFormUiVersion) {
		@case (ratingFormUiCaseV2) {
			<app-ts6-rating-form-v2></app-ts6-rating-form-v2>
		}
		@default {
			<app-ts6-rating-form></app-ts6-rating-form>
		}
	}
} @else if (formType == FORM_TYPE.ts_5) {
	@switch (ratingFormUiVersion) {
		@case (ratingFormUiCaseV2) {
			<app-ts5-rating-form-v2></app-ts5-rating-form-v2>
		}
		@default {
			<app-ts5-rating-form></app-ts5-rating-form>
		}
	}
} @else if (formType == FORM_TYPE.ts_3) {
	@switch (ratingFormUiVersion) {
		@case (ratingFormUiCaseV2) {
			<app-ts3-rating-form-v2></app-ts3-rating-form-v2>
		}
		@case (ratingFormUiCaseTs1V3) {
			<app-ts3-rating-form-v2></app-ts3-rating-form-v2>
		}
		@default {
			<app-ts3-rating-form></app-ts3-rating-form>
		}
	}
} @else if (formType == FORM_TYPE.cabin_crew) {
	@switch (ratingFormUiVersion) {
		@case (ratingFormUiCaseV2) {
			<app-cabin-crew-rating-form-v2></app-cabin-crew-rating-form-v2>
		}
		@case (ratingFormUiCaseTs1V3) {
			<app-cabin-crew-rating-form-v2></app-cabin-crew-rating-form-v2>
		}
		@default {
			<app-cabin-crew-rating-form></app-cabin-crew-rating-form>
		}
	}
} @else if (formType == FORM_TYPE.cabin_crew_instructor) {
	@switch (ratingFormUiVersion) {
		@case (ratingFormUiCaseV2) {
			<app-cabin-crew-instructor-rating-form-v2></app-cabin-crew-instructor-rating-form-v2>
		}
		@case (ratingFormUiCaseTs1V3) {
			<app-cabin-crew-instructor-rating-form-v2></app-cabin-crew-instructor-rating-form-v2>
		}
		@default {
			<app-cabin-crew-instructor-rating-form></app-cabin-crew-instructor-rating-form>
		}
	}
} @else {
	<div class="flex min-h-[40vh] items-center justify-center px-6 py-12 text-sm text-gray-600">Loading form…</div>
}
